module.exports = __webpack_public_path__ + "img/隐身.32c13f9b.png";